export default "__VITE_ASSET__BM7GrhQz__"